const productList = [
  {
    name: "Mac Book Air 2022",
    price: 2999,
    imgSrc: "https://www.reliancedigital.in/medias/Apple-MGN63HNA-Laptops-491946461-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxNzczNDJ8aW1hZ2UvanBlZ3xpbWFnZXMvaDVhL2gyZC85NDQzMDgzNTgzNTE4LmpwZ3xhYzRiNWIxZGQ2NjNiNWIyYjI0Y2ZkYTZlZWQ3MTFjZTMxYzVmNDBiNmM5Mzk5OTM2OGVkZmExMjMyYjIxNDQ4",
    id: 1,
  },
  {
    name: "HP Elitebook 840 G3",
    price: 1199,
    imgSrc: "https://m.media-amazon.com/images/I/410ph7PkE-L._SX300_SY300_QL70_FMwebp_.jpg",
    id: 2,
  },
  {
    name: "Google pixel 7 Pro",
    price: 1099,
    imgSrc: "https://m.media-amazon.com/images/I/61uzjnZpgzL._SX679_.jpg",
    id: 3,
  },
  {
    name: "Apple Iphone 14 Pro",
    price: 1299,
    imgSrc: "https://m.media-amazon.com/images/I/61HHS0HrjpL._AC_UY327_FMwebp_QL65_.jpg",
    id: 4,
  },
  {
    name: "Apple Airpodes Pro(2nd generation)",
    price: 249,
    imgSrc: "https://m.media-amazon.com/images/I/61SUj2aKoEL._AC_UL600_FMwebp_QL65_.jpg",
    id: 5,
  },
  {
    name: "Google Pixel Buds Pro",
    price: 229,
    imgSrc: "https://m.media-amazon.com/images/I/61DGBXMDMpL._SL1500_.jpg",
    id: 6,
  },
];

export default productList;
